/**
 * Share wording across the linear flow, guided setup, and dev gallery so gallery edits also reach user-
 * facing screens.
 */

export interface ThinkingScreenConfig {
    /** Selects a process illustration; omit when showing result skeletons. */
    art?: "week" | "wheel";
    label: string;
    /** Only shown in skeleton mode; illustrated screens ignore status. */
    status?: string;
    stages: string[];
    skeleton?: "readings" | "profile";
}

export type ThinkingWait = "scan" | "perspective" | "readings" | "profile";

export const THINKING_SCREENS: Record<ThinkingWait, ThinkingScreenConfig> = {
    /* Both live hosts override the label with the run's own, which names the window
       actually read and changes wording once the scan has overrun. */
    scan: {
        art: "week",
        label: "Reading the last 30 days of your calendar",
        stages: ["Pulling your meetings", "Working out who you spend the week with", "Writing your readings"],
    },
    perspective: {
        art: "wheel",
        label: "Working out where your answers put you",
        stages: ["Scoring your answers", "Placing you against the archetypes"],
    },
    readings: {
        label: "Re-reading your calendar with your answers",
        status: "The same meetings, read again now that I know how you like to work. About a minute.",
        stages: ["Matching your answers to your week", "Re-reading the meetings that cost you most", "Writing what changed"],
        skeleton: "readings",
    },
    profile: {
        label: "Writing your collaboration profile",
        status: "A draft in your own words, from everything you’ve told me. You’ll review it before anyone sees it.",
        stages: ["Pulling together what I know about you", "Drafting each section", "Checking it sounds like you"],
        skeleton: "profile",
    },
};
